import "@reach/dialog/styles.css";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { IMAGE_BASE_URL } from "../data/baseURL";

const WhatWeDo = ({ service, sliders }) => {
  const navigate = useNavigate();

  return (
    <>
      <section className="me-13 ms-13 mt-17">
        <div className="position-relative">
          <h1 className="text-center fs-56 gilroy-bold">{service?.heading}</h1>
          <div className="position-absolute mx-auto start-0 end-0 text-center service-img-position">
            <img
              src={`${IMAGE_BASE_URL}/${service?.image}`}
              loading="lazy"
              className="img-fluid"
              alt=""
            />
          </div>
        </div>
        <div className="container mt-7">
          <div className="row">
            {sliders?.slice(0, 6)?.map((slider, index) => (
              <div key={index} className="col-12 col-md-6 col-lg-4">
                <div
                  className="review-shadow bg-white rounded-lg cursor-pointer transform-up my-4 position-relative pb-4"
                  onClick={() => {
                    navigate(`/service/${slider?.id}`);
                  }}
                >
                  <div>
                    <img
                      src={`${IMAGE_BASE_URL}/${slider?.image}`}
                      alt={slider?.name}
                      style={{
                        borderRadius: "10px 10px 0 0",
                        // width: "100%",
                        // height: "35rem",
                      }}
                      className="img-fluid"
                    />
                    <div className="p-3">
                      <span>{}</span>
                      <h3 className="fs-20 my-3 text-capitalize text-charleston-green gilroy-bold">
                        {slider?.title}
                      </h3>
                      <p className="fs-16 text-secondary">
                        {slider?.short_description ||
                          "We offer a variety of fiber solutions from our towers and other connectivity services to support our customers’ digital strategies. "}
                      </p>
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="fs-16 text-secondary gilroy-bold">
                          {slider?.service_country?.length} Countries
                        </p>
                        <p className="fs-16 gilroy-bold text-secondary">
                          {slider?.site} Sites
                        </p>
                      </div>
                      <div className="review-card-border"></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="text-center my-5">
          <Link
            to="/services"
            className="text-decoration-none bg-american-yellow px-5 d-inline-block py-4 fs-14 text-white mb-5 text-uppercase"
          >
            View More
          </Link>
        </div>
      </section>
    </>
  );
};

export default WhatWeDo;
